// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e730051f","845":"0e048fb5"}[chunkId] + ".chunk.js";
};